import type { WeekAppointment } from "@/lib/dashboard-week";
import { OrganizacaoEmFoco } from "@/components/organization/painel/OrganizacaoEmFoco";
import { AppointmentDetailDialog } from "./AppointmentDetailDialog";

/** A consulta de outra clínica vista pela conta Pessoal: o diálogo de sempre, agindo naquela
 *  clínica sem trocar a organização ativa (o papel e o escopo valem os dela). */
export function ConsultaDeOutraClinica({ consulta, onClose }: { consulta: WeekAppointment | null; onClose: () => void }) {
  if (!consulta?.organizationId) return null;
  return (
    <OrganizacaoEmFoco key={consulta.organizationId} organizationId={consulta.organizationId}>
      <AppointmentDetailDialog appointment={consulta} onClose={onClose} />
    </OrganizacaoEmFoco>
  );
}
